import React from "react";

import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { QREditorContext } from "@/contexts/QREditorContext";

import { applyQRFormDefaultValues } from "@/utils/formHelper";
import { omittedValues } from "@/utils/qrEditorHelper";
import { qrEmailValidation } from "@/utils/validators/qr-email";

import { QREmailProps } from "./types";
import { useTranslation } from "react-i18next";
import { NAMESPACES } from "@/internals/constants/namespaces";
import "./styles.scss";

export const QREmail = ({ data }: QREmailProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = React.useContext<QREditorContextProps<"email">>(QREditorContext);

  const [qrEmailData, setQrEmailData] = React.useState<QRProps<"email">>(qrData);
  const [renderForm, setRenderForm] = React.useState(false);

  const dataEmailWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  const onUpdateState = ({ field, value }) => {
    setQrData({ ...qrData, data: { ...qrData.data, [field]: value } }, omittedValues(qrData.data));
  };

  React.useEffect(() => {
    setQrEmailData(qrData);
  }, [qrData]);

  React.useEffect(() => {
    setQrData({ ...qrEmailData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-email">
      <Typography
        Tag="p"
        size="xl"
        classname="u-bold u-spacing-5"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataEmailWithDefaultValues}
        schema={qrEmailValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
};
